import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as ProfileActions from '@profile/profile.actions';
import * as fromProfile from '@profile/profile.reducers';

@Component({
  selector: 'app-profile-email',
  templateUrl: './profile-email.component.html',
  styleUrls: ['./profile-email.component.scss'],
  standalone: false
})
export class ProfileEmailComponent implements OnInit, OnDestroy {
  emailForm: FormGroup;
  initialEmail: string;

  passwordValidated$: Observable<boolean>;
  loading$: Observable<boolean>;

  @Input() email: string;

  get emailControl(): AbstractControl | null {
    return this.emailForm.get('email');
  }

  constructor(
    private fb: FormBuilder,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.loading$ = this.store.select(fromProfile.selectLoading);
    this.passwordValidated$ = this.store.select(fromProfile.selectPasswordValidated);
    this.initialEmail = this.email;

    this.emailForm = this.createEmailForm(this.email);
  }

  ngOnDestroy(): void {
    this.store.dispatch(ProfileActions.validatePasswordReset());
  }

  createEmailForm(email: string): FormGroup {
    return this.fb.group({
      email: [email, [Validators.required, Validators.email]]
    });
  }

  onValidatePassword(password: string) {
    this.store.dispatch(ProfileActions.validatePassword({ password }));
  }

  onUpdateEmail() {
    if (this.emailForm.invalid) {
      return;
    }
    if (this.emailControl.value === this.initialEmail) {
      this.onCancel();
      return;
    }
    this.store.dispatch(ProfileActions.updateProfileEmail({ personalDetails: { email: this.emailControl.value } }));
  }

  onCancel() {
    this.store.dispatch(ProfileActions.updatePersonalDetailsCurrentScreen({ screen: 'main' }));
  }
}
